import { Card } from '@/components/ui/card'

/** Monospace ASCII diagram; wider than the column, it scrolls sideways inside its own card. */
export function DocsDiagram({ children }: { children: string }) {
  return (
    <Card className="my-6 rounded-lg bg-card/50 p-4 font-mono text-xs md:text-sm text-foreground overflow-x-auto">
      <pre className="whitespace-pre">{children}</pre>
    </Card>
  )
}
